/**
 * Card Product Swatches – Interactive color swatch switching on product cards.
 * Handles image swap, price update, and link update when a swatch is clicked.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-swatch__button');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var container = btn.closest('.card-swatches');
    if (!container) return;

    var card = btn.closest('.card-wrapper') || btn.closest('.product-card-wrapper') || btn.closest('.card') || btn.closest('.grid__item') || btn.closest('li');
    if (!card) return;

    // --- 1. Update active state ---
    container.querySelectorAll('.card-swatch__button').forEach(function (b) {
      b.classList.remove('card-swatch__button--active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('card-swatch__button--active');
    btn.setAttribute('aria-pressed', 'true');

    // --- 2. Swap product image ---
    var newImageSrc = btn.dataset.variantImage;
    var newImageSrcset = btn.dataset.variantImageSrcset;

    if (newImageSrc) {
      // Update ALL images in the card media (primary + hover/secondary image),
      // so the selected variant stays visible even while the card is hovered.
      var mediaImages = card.querySelectorAll('.card__media img, .media img, .card__inner img');
      if (!mediaImages.length) {
        mediaImages = card.querySelectorAll('img');
      }
      mediaImages.forEach(function (imgEl) {
        imgEl.src = newImageSrc;
        if (newImageSrcset) {
          imgEl.srcset = newImageSrcset;
        }
        if (btn.dataset.variantImageAlt) {
          imgEl.alt = btn.dataset.variantImageAlt;
        }
        if (btn.dataset.variantImageWidth) {
          imgEl.width = btn.dataset.variantImageWidth;
        }
        if (btn.dataset.variantImageHeight) {
          imgEl.height = btn.dataset.variantImageHeight;
        }
      });
    }

    // --- 3. Update product link ---
    var productUrl = btn.dataset.productUrl;
    if (productUrl) {
      card.querySelectorAll('a.full-unstyled-link').forEach(function (link) {
        link.href = productUrl;
      });
    }

    // --- 4. Update price ---
    var newPrice = btn.dataset.variantPrice;
    var newComparePrice = btn.dataset.variantComparePrice;
    var priceContainer = card.querySelector('.price');

    if (priceContainer && newPrice) {
      var regularPrice = priceContainer.querySelector('.price-item--regular');
      var salePrice = priceContainer.querySelector('.price-item--sale');
      var comparePriceEl = priceContainer.querySelector('.price-item--compare');

      if (newComparePrice && newComparePrice !== newPrice && newComparePrice !== '') {
        // Sale price scenario
        priceContainer.classList.add('price--on-sale');
        if (salePrice) salePrice.textContent = newPrice;
        if (comparePriceEl) comparePriceEl.textContent = newComparePrice;
        if (regularPrice && !salePrice) regularPrice.textContent = newPrice;
      } else {
        // Regular price scenario
        priceContainer.classList.remove('price--on-sale');
        if (regularPrice) regularPrice.textContent = newPrice;
        if (salePrice) salePrice.textContent = newPrice;
      }
    }

    // --- 5. Update hidden variant ID input (for quick add) ---
    var variantId = btn.dataset.variantId;
    if (variantId) {
      var variantInput = card.querySelector('input.product-variant-id');
      if (variantInput) {
        variantInput.value = variantId;
        var isAvailable = btn.dataset.variantAvailable === 'true';
        variantInput.disabled = !isAvailable;

        // Update submit button state
        var submitBtn = card.querySelector('.quick-add__submit');
        if (submitBtn) {
          if (isAvailable) {
            submitBtn.disabled = false;
            var spanEl = submitBtn.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
            if (spanEl) spanEl.textContent = submitBtn.closest('[data-sold-out-message]')
              ? window.variantStrings && window.variantStrings.addToCart || 'Warenkorb'
              : 'Warenkorb';
          } else {
            submitBtn.disabled = true;
            var spanEl2 = submitBtn.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
            if (spanEl2) spanEl2.textContent = window.variantStrings && window.variantStrings.soldOut || 'Ausverkauft';
          }
        }
      }
    }
  });
})();
